import React, { Component } from "react";

import { Select } from "@rocketseat/unform";

import Placa from "./Placa";

export default class Amarelo extends Component {
  /** Parte dos campos do formulário do filtro Amarelo */
  render() {
    return (
      <div>
        <div className="d-flex">
          <label className="big">B.O está correto?</label>
          <div className="filtro__input_container">
            <Select
              className="ant-input"
              name="bo_correto"
              options={[
                { id: 1, title: "SIM" },
                { id: 2, title: "NÃO" }
              ]}
            />
          </div>
        </div>
        <br />
        <Placa />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Filtro/components/Amarelo/index.js